<template>
  <div
    class="modal"
    tabindex="-1"
    aria-hidden="true"
    ref="editUserEmailModal"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content rounded-lg">
        <div class="modal-header justify-end pt-5 pb-0 border-0">
          <a
            data-dismiss="modal"
            href="javascript:;"
            class="font-poppins text-theme-23 font-medium hover:text-theme-35"
          >
            Cerrar
          </a>
        </div>
        <div class="px-10">
          <div class="modal-body pt-0">
            <h1
              class="font-crimson_pro text-theme-9 text-3xl font-bold text-center"
            >
              Editar mi correo
            </h1>
            <p class="text-center" v-if="step === 1">
              Ingresa un nuevo correo y te enviaremos un código de verificación
            </p>
            <p class="text-center" v-else>
              Ingresa el código de verificación que enviamos al correo:
              {{ email }}
            </p>
            <div class="flex flex-col w-full">
              <div class="intro-x mt-7" v-if="step === 1">
                <span class="text-xs">Correo</span>
                <input
                  type="text"
                  class="form-control p-2"
                  placeholder="mail@mail.com"
                  v-model="email"
                />
              </div>
              <div class="intro-x mt-7" v-else>
                <span class="text-xs">Código de verificación</span>
                <input
                  id="validation-form-2"
                  v-model.trim="code"
                  type="text"
                  required
                  class="intro-x login__input form-control py-3 px-4 border-theme-3 block mb-2"
                  :class="{ 'border-theme-6': v$.code.$error }"
                  placeholder="6 dígitos"
                  :maxlength="6"
                  :minlength="6"
                />
                <template v-if="v$.code.$errors">
                  <div
                    v-for="(error, index) in v$.code.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo Código de verificación es requerido</strong
                    >
                    <strong v-else>
                      El campo Código de verificación debe tener 6 caracteres
                    </strong>
                  </div>
                </template>
              </div>
              <div
                class="intro-x text-theme-4 text-center text-base mx-8"
                v-if="step === 2"
              >
                <button
                  type="button"
                  class="text-cpa-blue-link hover:underline text-center disabled:no-underline text-lg cursor-pointer disabled:cursor-not-allowed"
                  @click="sendEmail"
                  :disabled="Boolean(currentTime)"
                >
                  <span v-if="!currentTime"> Reenviar código </span>
                  <span v-else> Reenviar código en: {{ currentTime }} </span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer text-right">
            <div class="flex flex-col">
              <button
                type="button"
                :disabled="!checkEmailValidation"
                @click="sendOtp"
                class="btn btn-quotation rounded-lg px-5 w-full sm:w-9/12 text-base mx-auto"
                v-if="step === 1"
              >
                Siguiente
              </button>
              <button
                type="button"
                :disabled="v$.$invalid"
                @click="changeEmail"
                class="btn btn-quotation rounded-lg px-5 w-full sm:w-9/12 text-base mx-auto"
                v-else
              >
                Verificar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-quotation-outline rounded-lg px-5 mt-5 mb-3 w-full sm:w-9/12 text-base mx-auto"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { minLength, maxLength, required } from '@vuelidate/validators'
import { getFirstErrorMessage, cleanSession } from '@/utils/tools'
export default {
  data() {
    return {
      step: 1,
      modal: undefined,
      email: undefined,
      code: undefined,
      currentTime: 0
    }
  },
  setup() {
    return { v$: useVuelidate() }
  },
  validations() {
    return {
      code: {
        required,
        minLength: minLength(6),
        maxLenght: maxLength(6),
        $autoDirty: true
      }
    }
  },
  validationConfig: {
    $lazy: false
  },
  methods: {
    viewModal(view = 'show') {
      if (view === 'show') {
        this.step = 1
        this.email = ''
        this.code = ''
      }
      return cash(this.modal).modal(view)
    },
    async sendOtp() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          'otp/send-otp-email-to-change-email',
          {
            user_id: this.$store.state.auth.user?.id,
            email: this.email
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.step = 2
      } catch (error) {
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    sendEmail() {
      this.initCount()
    },
    async changeEmail() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          '/auth/modify-user-email',
          {
            email: this.email,
            code: this.code
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.$toast.success(
          'El correo ha sido cambiado correctamente, vuelve a iniciar sesión',
          {
            position: 'top'
          }
        )
        this.step = 1
        this.email = ''
        this.code = ''
        this.viewModal('hide')
        cleanSession(this.$store, this.$router)
      } catch (error) {
        console.log(error)
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    updateCounter() {
      if (this.currentTime != 0) {
        this.currentTime -= 1
        setTimeout(() => this.updateCounter(), 1000)
      }
    },
    initCount() {
      this.currentTime = 60
      this.updateCounter()
    }
  },
  mounted() {
    this.modal = this.$refs.editUserEmailModal
  },
  computed: {
    checkEmailValidation() {
      return (
        this.email &&
        this.email.length > 2 &&
        this.email.length <= 200 &&
        String(this.email)
          .toLowerCase()
          .match(/\S+@\S+\.\S+/)
      )
    }
  }
}
</script>
